module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBoldItalic.9221925.woff";